
const base = process.env.NODE_ENV === 'development' ? '/api': '/pro'
export default base